import { Button } from '../../../components/ui/button';

interface TimelineEmptyStateProps {
  onOpenSources: () => void;
}

export function TimelineEmptyState({ onOpenSources }: TimelineEmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-2 py-16 text-center">
      <p className="text-sm text-text-tertiary">Ingen hendelser i denne saken</p>
      <Button className="mt-2" variant="outline" onClick={onOpenSources}>
        Koble til en kilde for å importere data
      </Button>
    </div>
  );
}
